export const featureToggle = {
  // The value in .env file is "true" or "false" or none.
  // Use double-negation to get correct boolean value.
  MAP_ENABLED: process.env.REACT_APP_map_enabled === 'true',
  DEFAULT_DASHBOARD_ENABLED: process.env.REACT_APP_defaultDashboard_enabled === 'true',
  DEVCONSOLE_ENABLED: process.env.REACT_APP_devconsole_enabled === 'true'
};

export default featureToggle;